import axios from 'axios';
import { Order, Payment } from '../types';

const API_BASE_URL = process.env.REACT_APP_API_URL || 'http://localhost:8080/api';

const createApiInstance = () => {
    const token = localStorage.getItem('token');
    return axios.create({
        baseURL: API_BASE_URL,
        headers: {
            'Content-Type': 'application/json',
            ...(token && { Authorization: `Bearer ${token}` }),
        },
    });
};

export const orderAPI = {
    createOrder: async (order: Partial<Order>): Promise<Order> => {
        const api = createApiInstance();
        const response = await api.post('/orders', order);
        return response.data;
    },

    confirmOrder: async (id: string): Promise<Order> => {
        const api = createApiInstance();
        const response = await api.post(`/orders/${id}/confirm`);
        return response.data;
    },

    cancelOrder: async (id: string): Promise<Order> => {
        const api = createApiInstance();
        const response = await api.post(`/orders/${id}/cancel`);
        return response.data;
    },

    addPayment: async (id: string, payment: Partial<Payment>): Promise<Order> => {
        const api = createApiInstance();
        const response = await api.post(`/orders/${id}/payments`, payment);
        return response.data;
    },

    getOrdersByCompany: async (companyId: string): Promise<Order[]> => {
        const api = createApiInstance();
        const response = await api.get(`/orders/company/${companyId}`);
        return response.data;
    },

    getOrderById: async (id: string): Promise<Order> => {
        const api = createApiInstance();
        const response = await api.get(`/orders/${id}`);
        return response.data;
    },
    getOrdersByClient: async (clientId: string): Promise<Order[]> => {
        const api = createApiInstance();
        const response = await api.get(`/orders/client/${clientId}`);
        return response.data;
    },
    getOrdersBySupplier: async (supplierId: string): Promise<Order[]> => {
        const api = createApiInstance();
        const response = await api.get(`/orders/supplier/${supplierId}`);
        return response.data;
    },

    searchOrders: async (searchRequest: {
        companyId: string;
        status?: string;
        orderType?: string;
        orderId?: string;
        startDate?: string;
        endDate?: string;
        page?: number;
        size?: number;
    }): Promise<import('../types').PageResponse<Order>> => {
        const api = createApiInstance();
        const response = await api.post('/orders/search', {
            companyId: searchRequest.companyId,
            status: searchRequest.status || null,
            orderType: searchRequest.orderType || null,
            orderId: searchRequest.orderId || null,
            startDate: searchRequest.startDate || null,
            endDate: searchRequest.endDate || null,
            page: searchRequest.page || 0,
            size: searchRequest.size || 100,
        });
        return response.data;
    },
};
